import { useViewportWidth } from '@elfsight/widget-utils';
import type { Rect } from 'react-use-rect';
import { SHORT_HEIGHT, SHORT_OVERLAY, SHORT_WIDTH } from '../constants';
import type { PositionValue } from '../types';

type VerticalPosition = 'bottom' | 'top';
type HorizontalPosition = 'left' | 'center' | 'right';

export const usePosition = (
  coverRect: Rect | null | undefined
): [VerticalPosition, HorizontalPosition] => {
  const viewportWidth = useViewportWidth();

  const { width = 0, top = 0, left = 0, right = 0 } = coverRect || {};
  const derivedWidth = SHORT_WIDTH / 2;
  const derivedCoverWidth = width / 2;

  const verticalPosition: PositionValue =
    top < SHORT_HEIGHT - SHORT_OVERLAY ? 'bottom' : 'top';

  let horizontalPosition: 'center' | 'left' | 'right' = 'center';

  if (left + derivedCoverWidth < derivedWidth) {
    horizontalPosition = 'left';
  } else if (viewportWidth - right + derivedCoverWidth < derivedWidth) {
    horizontalPosition = 'right';
  }

  return [verticalPosition, horizontalPosition];
};
